// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f4022f1f","836":"d805830c","932":"e9a46534"}[chunkId] + ".chunk.js";
};